import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-email-success-step',
  standalone: true,
  imports: [CommonModule, MatButtonModule, TranslateModule, MatIconModule],
  host: { class: 'flex flex-col flex-1 min-h-0' },
  template: `
    <div class="flex flex-col flex-1 min-h-0">
      <div class="flex flex-col overflow-auto items-center justify-center flex-1 min-h-0">
        <div class="w-[64px] h-[64px] rounded-full flex items-center justify-center mb-8 shrink-0 scale-animation" style="background-color: #BAEAFF;">
          <mat-icon svgIcon="check" class="icon-size [--icon-size:40px]" />
        </div>
        <p class="text-center" style="font-family: 'DM Sans', sans-serif; font-size: 24px; font-weight: 400; color: #004562; line-height: 1.33; letter-spacing: 0.5px;">
          {{ 'Your email address has been validated' | translate }}
        </p>
      </div>

      <div class="pt-4 shrink-0">
        <button
          mat-flat-button
          class="!rounded-xl !py-3 !h-auto !text-base w-full"
          color="primary"
          (click)="next.emit()"
        >
          {{ 'Continue' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    @keyframes scaleIn {
      0% { transform: scale(0); opacity: 0; }
      60% { transform: scale(1.1); }
      100% { transform: scale(1); opacity: 1; }
    }
    .scale-animation {
      animation: scaleIn 0.5s ease-out;
    }
  `],
})
export class EmailSuccessStepComponent {
  @Output() next = new EventEmitter<void>();
}
